import { Biases } from './biases/Biases';
import { BiasesCarousel } from "./carousel/BiasesCarousel";
import { History } from "./state/History";
import { DetailView } from "./carousel/DetailView";
import { HeroView } from "./carousel/HeroView";

new Biases(bootstrap);

window.appHistory = new History();

function bootstrap(biases) {
  if (document.getElementById('biases-carousel')) {
    new BiasesCarousel({
      selector: '#biases-carousel',
      biases,
      view: new HeroView(),
      autostart: true
    });
  }

  if (document.getElementById('fallacy-detailed')) {
    new BiasesCarousel({
      selector: '#fallacy-detailed',
      slug: location.pathname.replace(/^\//, ''),
      biases,
      view: new DetailView()
    });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/src/bootstrap.js